import script from "./colorMng.vue?vue&type=script&setup=true&name=colorMng&lang=js"
export * from "./colorMng.vue?vue&type=script&setup=true&name=colorMng&lang=js"

const __exports__ = script;

export default __exports__